import { render, staticRenderFns } from "./QuarterlySlideControls.vue?vue&type=template&id=60758e8c&scoped=true&"
import script from "./QuarterlySlideControls.vue?vue&type=script&lang=js&"
export * from "./QuarterlySlideControls.vue?vue&type=script&lang=js&"
import style0 from "./QuarterlySlideControls.vue?vue&type=style&index=0&id=60758e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60758e8c",
  null
  
)

export default component.exports